import styled from 'styled-components';
import Divider from '@material-ui/core/Divider';

export const StyledDivider = styled(Divider)`
  && {
    background-color: #c2d1d9;
    margin-bottom: 10px;
  }
`;
